import { markUiObject as __markUi } from '@/i18n/display'
// Resolve the account behind an order; never match masked or delivery phone text.
export function memoCustomerId(row:any):number {
  const ids=new Set<number>(),seen=new Set<any>();
  const visit=(value:any)=>{if(!value || seen.has(value))return;seen.add(value);const id=Number(value.customerId);if(Number.isSafeInteger(id)&&id>0)ids.add(id);['details','sizeNames','groups','subRows'].forEach(key=>{if(Array.isArray(value[key]))value[key].forEach(visit)})};visit(row);
  return ids.size===1?Array.from(ids)[0]:0;
}
export function withCustomerMemo(columns:any[],enabled:boolean,afterKey?:string):any[]{
  if(!enabled)return columns;
  const result=columns.filter(column=>column.key!=='customerMemo');
  const timeAt=result.findIndex(column=>/^(orderTime|createTime|createdAt)$/.test(String(column.dataIndex||column.key)));
  const afterAt=afterKey?result.findIndex(column=>(column.dataIndex || column.key)===afterKey):-1;
  const at=afterAt>=0?afterAt+1:timeAt>=0?timeAt:result.findIndex(column=>/^(commands?|subcommand|operate|operations?|actions?|refound)$/.test(String(column.dataIndex||column.key)));
  result.splice(at<0?result.length:at,0,__markUi({title:'备注',dataIndex:'customerMemo',key:'customerMemo',width:110}, {"title":"备注"}));
  return result;
}
